export enum FirebaseError {
  DOC_HAS_EXIST = 'DOC_HAS_EXIST',
}
